import React from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "shared/context/LanguageContext";

const HAAT_LOGO_URL = "https://haatdaas.lan-wan.net/daas/images/logo.svg";

const LoginLeftPanel: React.FC = () => {
  const { t } = useTranslation();
  const { dir } = useLanguage();

  return (
    <div
      dir={dir}
      className="relative hidden h-full w-1/2 shrink-0 flex-col justify-between overflow-hidden p-10 text-white lg:flex"
      aria-hidden="true"
      style={{
        background:
          "linear-gradient(145deg, #7f1d1d 0%, #991b1b 30%, #450a0a 100%)",
      }}
    >
      <div
        className="pointer-events-none absolute -bottom-24 -left-24 h-80 w-80 rounded-full opacity-20"
        style={{ background: "radial-gradient(circle, #fbbf24, transparent)" }}
      />
      <div
        className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full opacity-10"
        style={{ background: "radial-gradient(circle, #ef4444, transparent)" }}
      />

      <div className="relative flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/10 p-1.5">
          <img
            src={HAAT_LOGO_URL}
            alt="HAAT"
            className="h-full w-full object-contain"
          />
        </div>
        <div className="flex flex-col items-start text-left leading-tight">
          <span className="text-lg font-black tracking-widest text-white">
            HAAT
          </span>
          <span className="text-[10px] font-semibold tracking-[0.25em] text-white/60">
            COURIERS ONBOARDING
          </span>
        </div>
      </div>

      <div className="relative">
        <h1 className="mb-4 max-w-xl text-4xl font-bold leading-tight text-white xl:text-5xl">
          {t("courierAuth.left.title")}
        </h1>
        <p className="max-w-md text-lg text-white/80">
          {t("courierAuth.left.subtitle")}
        </p>
      </div>

      <div className="relative">
        <span className="text-xs text-white/40">
          {t("courierAuth.footer.copyright", {
            year: new Date().getFullYear(),
          })}
        </span>
      </div>
    </div>
  );
};

export default LoginLeftPanel;
